var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.firstRendered) ? _c('div', [_c('div', {
    staticClass: "filter-condition box-shadow-small border-radius"
  }, [_c('multi-search', {
    attrs: {
      "fields": _vm.multiFields
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-result background-white box-shadow-small border-radius"
  }, [_c('div', {
    staticClass: "filter-result-header clearfix mt-10"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.multiProcess('writtenArrangement')
      }
    }
  }, [_vm._v("批量笔试安排")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.multiProcess('writtenRecommend')
      }
    }
  }, [_vm._v("批量笔试推荐")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'writtenExamList'
        })
      }
    }
  }, [_vm._v("查看笔试安排列表")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.multiRemarkEdit(_vm.idStr)
      }
    }
  }, [_vm._v("批量编辑备注")]), _vm._v(" "), _c('el-dropdown', {
    staticClass: "ml-10"
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-daochu",
      "type": "primary"
    }
  }, [_vm._v("导出简历"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, '/arrangeExam')
      }
    }
  }, [_vm._v("导出已选记录(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportFiles(_vm.idStr, '/arrangeExam', undefined, 'type=HTML')
      }
    }
  }, [_vm._v("导出已选记录(html)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportParamsFiles('/arrangeExam/exportAllResume.api')
      }
    }
  }, [_vm._v("导出所有查询结果(excel)")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.exportParamsFiles('/arrangeExam/exportAllResume.api', 'HTML')
      }
    }
  }, [_vm._v("\n                                导出所有查询结果(html)\n                            ")])], 1)], 1), _vm._v(" "), _c('export-custom-dialog', {
    attrs: {
      "valid-call-back": _vm.customExportValid,
      "params-call-back": _vm.customExportParams
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.lists.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-my-queding color-success",
      "type": "success",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'pass')
      }
    }
  }, [_vm._v("通过\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-daiding color-warning",
      "type": "warning",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'undetermined')
      }
    }
  }, [_vm._v("待定\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'notPass')
      }
    }
  }, [_vm._v("淘汰\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-lahei color-purple",
      "type": "purple",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'lh')
      }
    }
  }, [_vm._v("拉黑\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-huitui color-info",
      "type": "info",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'back')
      }
    }
  }, [_vm._v("回退\n                        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "icon": "el-icon-my-guanbi color-danger",
      "type": "danger",
      "plain": true
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(_vm.idStr, 'fq')
      }
    }
  }, [_vm._v("放弃\n                        ")])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.partialLoading),
      expression: "partialLoading"
    }]
  }, [_c('empty-tip', {
    attrs: {
      "show": !_vm.lists.length
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-list mt-20"
  }, [(_vm.lists.length) ? _c('el-table', {
    attrs: {
      "data": _vm.lists
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "fixed": "",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "fixed": "",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [(scope.row.operateReason) ? _c('el-tooltip', {
          attrs: {
            "effect": "dark",
            "content": scope.row.operateReason,
            "placement": "top-start"
          }
        }, [_c('span', [_c('status-icon', {
          attrs: {
            "icon": ['not-deal', 'undetermined', 'not-pass', 'lh', 'fq'][scope.row.resumeStatus.substr(2)]
          }
        }), _c('i', {
          staticClass: "el-icon-my-xinxi"
        })], 1)]) : _c('status-icon', {
          attrs: {
            "icon": ['not-deal', 'undetermined', 'not-pass', 'lh', 'fq'][scope.row.resumeStatus.substr(2)]
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "name-txt eclip-name-txt",
          attrs: {
            "title": scope.row.name
          },
          on: {
            "click": function($event) {
              return _vm.toResumeDetail(scope.row)
            }
          }
        }, [_vm._v("\n                                    " + _vm._s(scope.row.name) + "\n                                ")])], 1)]
      }
    }], null, false, 3961304189)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s({
          1: '男',
          2: '女'
        }[scope.row.gender] || '-'))]
      }
    }], null, false, 3151373380)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "岗位",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.positionName) + "\n                        ")]
      }
    }], null, false, 2940168419)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "招聘部门",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.row.deptNames) + "\n                        ")]
      }
    }], null, false, 3474352204)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "邮箱",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "degree",
      "label": "最高学历",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_EDU_DEGREE', scope.row.degree)) + "\n                        ")]
      }
    }], null, false, 4066434606)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "school",
      "label": "最高学历学校",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "major",
      "label": "专业",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简历来源",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeSource) || '-') + "\n                        ")]
      }
    }], null, false, 3000401975)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "residence",
      "label": "当前所在地",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "应聘城市",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_POSITION_CITY', scope.row.expectCityId)) + "\n                        ")]
      }
    }], null, false, 4273930065)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "positionForm.sourceFrom",
      "label": "投递渠道",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_ADD_SOURCE',
          scope.row.addSource)) + "\n                        ")]
      }
    }], null, false, 1900089712)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "投递人",
      "prop": "addName",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "推荐人",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.recommender) ? _c('span', [_vm._v(_vm._s(scope.row.recommender.name))]) : _vm._e()]
      }
    }], null, false, 1484247024)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "投递时间",
      "show-overflow-tooltip": true,
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.dateFormat(scope.row.commitTime)))]
      }
    }], null, false, 3274253775)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考试场次",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scoped) {
        return [_c('router-link', {
          staticClass: "exam-name-span",
          attrs: {
            "title": scoped.row.examName,
            "target": "_blank",
            "to": ("/written/exam/detail/" + (scoped.row.examId))
          }
        }, [_vm._v(_vm._s(scoped.row.examName))]), _vm._v(" "), (scoped.row.examTimes.length) ? _c('el-popover', {
          attrs: {
            "placement": "top",
            "popper-class": "dark-theme popper-line",
            "trigger": "hover"
          }
        }, [_c('div', {
          staticStyle: {
            "width": "220px"
          }
        }, [_c('p', [_vm._v("考试时间")]), _vm._v(" "), _vm._l((scoped.row.examTimes), function(item, index) {
          return _c('p', {
            key: index
          }, [_vm._v(_vm._s(item.startTime) + "-" + _vm._s(item.endTime.slice(10)))])
        })], 2), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "el-icon-my-xinxi color-primary"
        })])]) : _vm._e()]
      }
    }], null, false, 1402188680)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "答卷",
      "prop": "paperName",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scoped) {
        return [(scoped.row.paperName) ? [_c('router-link', {
          attrs: {
            "target": "_blank",
            "to": ("/written/topic/" + (scoped.row.paperId) + "?resumePositionId=" + (scoped.row.resumePositionId) + "&examId=" + (scoped.row.examId))
          }
        }, [_vm._v(_vm._s(scoped.row.paperName))])] : _vm._e()]
      }
    }], null, false, 1601771769)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "答卷时间段",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scoped) {
        return [(scoped.row.startTime && scoped.row.endTime) ? [_vm._v(_vm._s(scoped.row.startTime) + "-" + _vm._s(scoped.row.endTime.slice(10)))] : _vm._e()]
      }
    }], null, false, 1879860894)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "考试状态",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(_vm.getSelectMapText('WB_RESUME_EXAM_STATUS', scope.row.examStatus)) + "\n                            "), (scope.row.examStatus) ? _c('el-popover', {
          attrs: {
            "placement": "top",
            "popper-class": "dark-theme popper-line text-center tooltip-status-popover",
            "value": scope.row.isExamStatusShow,
            "trigger": "manual"
          },
          nativeOn: {
            "mouseenter": function($event) {
              return _vm.searchScore(scope.row)
            },
            "mouseleave": function($event) {
              return _vm.hideTooltip(scope.row)
            }
          }
        }, [_c('div', {
          staticStyle: {
            "width": "300px"
          }
        }, [(_vm.oneScoreList.length) ? _c('span', [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_vm._v("评估人")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_vm._v("评分")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 5
          }
        }, [_vm._v("状态")]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 9
          }
        }, [_vm._v("备注")])], 1), _vm._v(" "), _vm._l((_vm.oneScoreList), function(item, index) {
          return _c('el-row', {
            key: index
          }, [_c('el-col', {
            attrs: {
              "span": 5
            }
          }, [_vm._v(_vm._s(item.markName))]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 5
            }
          }, [_vm._v(_vm._s(item.score || '-'))]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 5
            }
          }, [_vm._v(_vm._s(item.result || '-'))]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 9
            }
          }, [_vm._v(_vm._s(item.remark || '-'))])], 1)
        })], 2) : _c('el-row', [_vm._v("暂无数据")])], 1), _vm._v(" "), _c('span', {
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('i', {
          staticClass: "el-icon-my-xinxi color-primary"
        })])]) : _c('span', [_vm._v("-")])]
      }
    }], null, false, 3769297722)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评分",
      "prop": "score",
      "show-overflow-tooltip": true,
      "align": "center",
      "formatter": _vm.tableColumnFormatter,
      "min-width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "class-name": "no-wrap",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-dropdown', {
          staticClass: "mr-10",
          attrs: {
            "hide-on-click": false
          },
          on: {
            "command": _vm.handleCommand
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_vm._v("笔试评估")]), _vm._v(" "), _c('el-dropdown-menu', {
          attrs: {
            "slot": "dropdown"
          },
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/pass")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-queding color-success mr-10"
        }), _vm._v("通过\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/undetermined")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-daiding color-warning mr-10"
        }), _vm._v("待定\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/notPass")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-guanbi color-danger mr-10"
        }), _vm._v("淘汰\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/lh")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-lahei color-purple mr-10"
        }), _vm._v("拉黑\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/back")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-huitui color-info mr-10"
        }), _vm._v("回退\n                                    ")]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "command": ((scope.row.id) + "/fq")
          }
        }, [_c('i', {
          staticClass: "el-icon-my-guanbi color-danger mr-10"
        }), _vm._v("放弃\n                                    ")])], 1)], 1), _vm._v(" "), _c('router-link', {
          attrs: {
            "to": ("/written/recommend/" + (scope.row.id))
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v("笔试推荐")])], 1)]
      }
    }], null, false, 3475871136)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "show-overflow-tooltip": true,
      "label": "备注",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('remark-edit', {
          attrs: {
            "id": scope.row.resumeId
          },
          model: {
            value: (scope.row.resumeRemark),
            callback: function($$v) {
              _vm.$set(scope.row, "resumeRemark", $$v)
            },
            expression: "scope.row.resumeRemark"
          }
        })]
      }
    }], null, false, 1923734144)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "resumeForm.remark",
      "show-overflow-tooltip": true,
      "label": "最近操作人",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.lastOperateUserName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)))])])]
      }
    }], null, false, 3685772737)
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.lists.length) ? _c('el-pagination', {
    staticClass: "text-center mt-20 mb-20",
    attrs: {
      "current-page": _vm.pagination.pageIndex,
      "page-size": _vm.pagination.pageSize,
      "page-sizes": [20, 50, 100, 200],
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pagination.recordCounts
    },
    on: {
      "size-change": _vm.pageSizeChange,
      "current-change": _vm.pageIndexChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('multi-remark-edit-dialog', {
    ref: "multiRemarkEditDialog",
    on: {
      "reload": _vm.fetchData
    }
  })], 1)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e506567"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/written/writtenList.vue
// module id = null
// module chunks = 